module.exports = __webpack_public_path__ + "static/media/core_features.a87a4806.yml";